import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/header/Header";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import { authAPI } from "../services/api";
import "./Login.scss";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    document.title = "Forgot Password - Talsolution";
    return () => {
      document.title = "Talsolution";
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    if (!email) {
      setError("Please enter your email address");
      return;
    }
    setLoading(true);
    try {
      const response = await authAPI.forgotPassword(email);
      if (response.data.success) {
        setSuccess(true);
        setError("");
      } else {
        setError(response.data.message || "Something went wrong");
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to send reset email. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <section className="login-page-section">
        <div className="login-page-container">
          <div className="login-page-content">
            <div className="account-section">
              <div className="tf-container">
                <div className="row">
                  <div className="wd-form-login" style={{ width: "100%" }}>
                    <div className="login-header-text">
                      <h4>Forgot password?</h4>
                      <p>
                        Enter your email address and we&apos;ll send you a link
                        to reset your password.
                      </p>
                    </div>
                    {error && (
                      <div className="alert alert-danger">{error}</div>
                    )}
                    {success ? (
                      <div className="nofi-form">
                        <p>
                          If an account exists with this email, a password reset
                          link has been sent. Please check your inbox and follow
                          the instructions.
                        </p>
                        <Link to="/login" className="back-button">
                          <i className="icon-keyboard_arrow_left" />
                          Back to Login
                        </Link>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit}>
                        <div className="ip">
                          <label>
                            Email address<span>*</span>
                          </label>
                          <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="your.email@example.com"
                            required
                            autoFocus
                          />
                        </div>
                        <button type="submit" disabled={loading}>
                          {loading ? "Sending..." : "Send Reset Link"}
                        </button>
                        <div className="sign-up">
                          Remember your password?{" "}
                          <Link to="/login">Login</Link>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Gotop />
    </>
  );
}

export default ForgotPassword;
